// Route added to migrate from flutterflow
import { Navigate } from "@tanstack/react-router";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/AIAssistant")({
  component: () => <Navigate to="/user/subscription/box/edit" />,
  beforeLoad: () => {
    document.title = "Maifud - Editar caja";
  },
});
